import { List } from 'immutable';

export default function applySortAction<T>(list: List<T>, oldIndex: number, newIndex: number): List<T> {
  if (oldIndex === newIndex) { return list; }
  const target = list.get(oldIndex);
  if (target === undefined) { throw Error('applySortAction: undefined target'); }

  return list.delete(oldIndex).insert(newIndex, target);
}
